import Modal from "bootstrap/js/dist/modal";

//gallery modal
document.querySelectorAll(".gallery-item").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();
        const fullImg = item.getAttribute("href");
        const modalImage = document.getElementById("modalImage");
        modalImage.src = fullImg;
        //carry the thumbnail's alt text across, so the modal is not an unlabelled image
        const thumb = item.querySelector("img");
        modalImage.alt = thumb ? thumb.getAttribute("alt") || "" : "";
        const modal = new Modal(document.getElementById("galleryModal"));
        modal.show();
    });
});

//close the modal on click
function closeModal() {
    const galleryModalElement = document.getElementById("galleryModal");
    if (!galleryModalElement) {
        return;
    }
    galleryModalElement.addEventListener("click", () => {
        const myModal = Modal.getInstance(galleryModalElement);
        myModal.hide();
    });
}
closeModal();

//gallery page load more
//The hidden items carry their thumbnail URL and alt text on the anchor (data-gallery-src /
//data-gallery-alt) and hold no <img>, so image-optimizer plugins have nothing to rewrite. The
//fallbacks below cover markup produced by the older template, which may still be sitting in a
//plugin's HTML cache: such an <img> has had its data-src consumed and re-published under a
//plugin-private name.
const GALLERY_SRC_ATTRS = [
    "data-src",
    "data-wpc-qw-src",
    "data-wpc-fb",
    "data-lazy-src",
];

function galleryThumbUrl(hiddenItem) {
    const own = hiddenItem.getAttribute("data-gallery-src");
    if (own) {
        return own;
    }
    const img = hiddenItem.querySelector("img");
    if (!img) {
        return null;
    }
    for (const attr of GALLERY_SRC_ATTRS) {
        const value = img.getAttribute(attr);
        if (value) {
            return value;
        }
    }
    //a real src that is not a placeholder is already usable
    const src = img.getAttribute("src");
    return src && src.indexOf("data:") !== 0 ? src : null;
}

document.querySelectorAll("#gallery-load-more").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();

        //get the hidden gallery items
        const hiddenItems = document.querySelectorAll(".gallery-item.d-none");
        if (!hiddenItems.length) {
            return;
        }
        let revealed = 0;
        //loop through the hidden items and show them
        hiddenItems.forEach((hiddenItem) => {
            const thumbUrl = galleryThumbUrl(hiddenItem);
            if (!thumbUrl) {
                return;
            }
            //build the image if the item does not already carry one
            let img = hiddenItem.querySelector("img");
            if (!img) {
                img = document.createElement("img");
                img.alt = hiddenItem.getAttribute("data-gallery-alt") || "";
                hiddenItem.appendChild(img);
            }
            //set the src attribute
            img.src = thumbUrl;
            //remove the hidden class
            hiddenItem.classList.remove("d-none");
            revealed += 1;
        });
        //only retire the button if it actually did something: a silent failure here reads as a
        //caching bug, a button that stays put reads as the bug it is
        if (revealed) {
            item.remove();
        }
    });
});

// FAQ accordion
document.querySelectorAll(".accordion .accordion-button").forEach((button) => {
    button.addEventListener("click", () => {
        const accordion = button.closest(".accordion");
        if (!accordion) {
            return;
        }

        accordion.classList.toggle("active");
    });
});

// Service areas accordion
var acc = document.querySelectorAll(".service-area-inner button.accordion");
var i;
for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
    });
}

//modify the functionality of the main menu with dropdowns on desktop
document.querySelectorAll(".navbar-nav a.dropdown-toggle").forEach((item) => {
    item.addEventListener("click", (e) => {
        //stop propagation
        e.stopPropagation();

        //get the href attribute
        const href = item.getAttribute("href");
        if (href === "#") {
            return;
        }

        //find the element with the class .offcanvas-start in the element's parent tree
        const offcanvasStart = item.closest(".offcanvas-start");
        if (!offcanvasStart) {
            return;
        }

        //check if the offcanvas has the show class
        const isOffcanvasShown = offcanvasStart.classList.contains("show");
        if (isOffcanvasShown) {
            return;
        }

        //go to the href
        window.location.href = href;
    });
});

//when the mobile menu is shown, check the position
let navbarToggler = document.querySelector(".navbar-toggler");
if (navbarToggler) {
    navbarToggler.addEventListener("click", () => {
        //get the .header-inner element
        let headerInner = document.querySelector(
            "#wrapper-navbar .header-inner",
        );
        if (!headerInner) {
            return;
        }

        //get the vertical position of the button relative to the window
        let pozY = navbarToggler.getBoundingClientRect().top;

        if (!pozY) {
            return;
        }

        if (pozY < 30) {
            //add class .scrolling to the .header-inner element
            headerInner.classList.add("scrolling");
        } else {
            //remove class .scrolling from the .header-inner element
            headerInner.classList.remove("scrolling");
        }
    });
}

// Wild Oak (B9b): in-page anchor targets clear the sticky header at every width. The header's
// height changes with the breakpoint (and wraps at some widths), so its real bottom edge is
// measured and exposed as --wo-anchor-offset (+24px of air); the CSS scroll-margin-top of the
// post headings uses it, with the base's fixed values as the fallback.
(function () {
    var header = document.querySelector("#wrapper-navbar .header-inner");
    var sticky = header ? header.closest("#wrapper-navbar") : null;
    if (!header || !sticky) {
        return;
    }
    function setAnchorOffset() {
        // Where the header's bottom edge sits once the bar is stuck (while scrolling), whatever
        // the current scroll position: its offset inside the sticky wrapper + the wrapper's
        // `top` + its own height.
        var offsetInWrapper = header.getBoundingClientRect().top - sticky.getBoundingClientRect().top;
        var stickyTop = parseFloat(getComputedStyle(sticky).top) || 0;
        var bottom = Math.ceil(stickyTop + offsetInWrapper + header.offsetHeight);
        if (bottom > 0) {
            document.documentElement.style.setProperty("--wo-anchor-offset", bottom + 24 + "px");
        }
    }
    setAnchorOffset();
    window.addEventListener("load", setAnchorOffset);
    window.addEventListener("resize", setAnchorOffset);
})();
